export default {
  tableHeader: {
    observationCount: 'Amount',
  },
  empty: 'No observations found',
};
